import { useMutation, useQueryClient } from "react-query";
import { AxiosError } from "axios";
import { UpdateDefaultPlaylist, putFavourite } from "@/api";
import { useUser } from "@/providers/context";

export const usePutFavourite = () => {
  const queryClient = useQueryClient();
  const { uid } = useUser();
  return useMutation<
    unknown,
    AxiosError<{ error: string }>,
    Omit<UpdateDefaultPlaylist, "UserId">
  >(
    async (favourite) => {
      if (uid) {
        return await putFavourite({ ...favourite, UserId: uid });
      }
    },
    {
      onSuccess: (data) => {
        // Update the local favourites immediately with the response from the PUT
        if (data) {
          queryClient.setQueryData(["favourites", uid], data);
        }
      },
    },
  );
};
